import { render, staticRenderFns } from "./paneConfig.vue?vue&type=template&id=5286d5c5&scoped=true"
import script from "./paneConfig.vue?vue&type=script&lang=js"
export * from "./paneConfig.vue?vue&type=script&lang=js"
import style0 from "./paneConfig.vue?vue&type=style&index=0&id=5286d5c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5286d5c5",
  null
  
)

export default component.exports